import { __decorate, __metadata } from "tslib";
import { PaymentProviderEnum, SupportedCurrencyEnum } from '@goparrot/common';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsEnum, IsNotEmpty, IsOptional, IsString } from 'class-validator';
import { StoreExposeGroup } from '../interface';
export class ReadStorePaymentDto {
}
__decorate([
    ApiProperty({ enum: SupportedCurrencyEnum, default: SupportedCurrencyEnum.USD }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsNotEmpty({ always: true }),
    IsEnum(SupportedCurrencyEnum, { groups: [StoreExposeGroup.CREATE, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], ReadStorePaymentDto.prototype, "currency", void 0);
__decorate([
    ApiPropertyOptional({}),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsEnum(PaymentProviderEnum, { groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], ReadStorePaymentDto.prototype, "provider", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, minLength: 3, maxLength: 50, example: 'Merchant GoParrot' }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    IsOptional({ groups: [StoreExposeGroup.PATCH] }),
    IsString({ groups: [StoreExposeGroup.UPDATE, StoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], ReadStorePaymentDto.prototype, "merchantTitle", void 0);
//# sourceMappingURL=ReadStorePaymentDto.js.map